import './CopyA.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { ComponentWrapper } from './ComponentWrapper';
import { CopyAContentType } from './contentTypes';

export const CopyA = ({ content, headingType, options, textAlign }: CopyAContentType) => {
  const _textAlign = textAlign as b2x.TextAlign;
  const _headingType = headingType as string;

  return (
    <ComponentWrapper classNames="copy-a" options={options}>
      <b2x.Row justifyContent={'center'}>
        <b2x.Col size={{ md: 8, xl: 6, xs: 10 }}>
          <b2x.Div
            className="content"
            display={'flex'}
            flexDirection={'column'}
            gap={{ lg: 5, xs: 4 }}
            textAlign={{ lg: _textAlign, xs: 'center' }}
          >
            {content?.title && React.createElement(_headingType, { class: 'h1 m-0' }, b2x.formatHtml(content.title))}
            {content?.message && <b2x.Div className="h3 m-0">{b2x.formatHtml(content.message)}</b2x.Div>}
            {content?.cta?.label && (
              <b2x.Div>
                <b2x.CtaFromContent
                  {...content.cta}
                  variant={content.cta.variant !== '' ? content.cta.variant : 'primary'}
                />
              </b2x.Div>
            )}
          </b2x.Div>
        </b2x.Col>
      </b2x.Row>
    </ComponentWrapper>
  );
};
